var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 27,
    viewBox: "0 0 39 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_3023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5519 4.21125C37.3317 3.39728 36.902 2.65522 36.3058 2.05894C35.7095 1.46267 34.9675 1.03299 34.1535 0.8127C31.1736 0 19.1805 0 19.1805 0C19.1805 0 7.18683 0.0245999 4.20693 0.8373C3.39295 1.0576 2.65089 1.4873 2.05464 2.08361C1.4584 2.67991 1.02876 3.42201 0.808529 4.236C-0.0928212 9.5307 -0.442471 17.5986 0.833279 22.6815C1.05353 23.4955 1.48318 24.2375 2.07943 24.8338C2.67567 25.4301 3.41772 25.8598 4.23168 26.08C7.21158 26.8927 19.205 26.8927 19.205 26.8927C19.205 26.8927 31.1982 26.8927 34.178 26.08C34.992 25.8598 35.734 25.4301 36.3303 24.8338C36.9266 24.2376 37.3563 23.4955 37.5765 22.6815C38.5272 17.3793 38.8202 9.31635 37.5519 4.21125Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3633 19.209L25.3125 13.4463L15.3633 7.68359V19.209Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_3023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 27,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fce72a72a15fbbb88f790c28430cd1a0.svg";
export { ForwardRef as ReactComponent };